export const rowsFrom = (response) => response.data?.results || response.data || [];

export const fetchAllCustomers = async (axiosInstance) => {
  const customers = [];
  let page = 1;
  let hasNext = true;

  while (hasNext && customers.length < 1000) {
    const response = await axiosInstance.get(
      `/accounts/customers/?page_size=500&page=${page}`,
    );
    customers.push(...rowsFrom(response));
    hasNext = Boolean(response.data?.next);
    page += 1;
  }

  return customers.slice(0, 1000);
};

export const normalizeMobile = (value) => {
  let number = String(value || "").replace(/\D/g, "");
  if (number.startsWith("0098")) number = number.slice(4);
  else if (number.startsWith("98")) number = number.slice(2);
  if (number.startsWith("9") && number.length === 10) number = `0${number}`;
  return /^09\d{9}$/.test(number) ? number : "";
};

export const parseCustomNumbers = (value) =>
  value
    .split(/[\s,;،]+/)
    .map((item) => item.trim())
    .filter(Boolean);

export const getSmsMetrics = (message) => {
  const isUnicode = Array.from(message).some(
    (character) => character.codePointAt(0) > 127,
  );
  const singleLimit = isUnicode ? 70 : 160;
  const multipartLimit = isUnicode ? 67 : 153;
  const segments = message.length
    ? Math.ceil(
        message.length /
          (message.length <= singleLimit ? singleLimit : multipartLimit),
      )
    : 0;

  return { characters: message.length, segments };
};

export const formatDateTime = (value) =>
  value ? new Date(value).toLocaleString("fa-IR") : "-";
